export const GRAPH_HEIGHT = 150;
export const LABEL_OFFSET = 118;
export const LABEL_X_POSITION = (containerWidth: number) =>
  containerWidth - LABEL_OFFSET;
